import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { SocialComponent } from "components/Social/Social-component/Social-component";
import { IProfileData } from "store/types/user/social";

interface ProfilePreviewModalProps {
  profile: IProfileData | null;
  onClose: () => void;
}

export const ProfilePreviewModal: React.FC<ProfilePreviewModalProps> = ({ profile, onClose }) => {
  return (
    <Dialog
      open={!!profile}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: "10px",
            bgcolor: "#F6F8FC",
            maxHeight: "90vh"
          }
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#edf1f9",
          py: "12px",
          px: "24px"
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: 500, color: "#0a3142" }}>
          {profile?.details.full_name}
        </Typography>
        <IconButton onClick={onClose} sx={{ p: "4px" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, overflow: "auto", display: "flex", justifyContent: "center" }}>
        {profile && (
          <SocialComponent
            key={profile.details.id}
            data={profile}
            btnTitle="Connect"
            btnHandler={() => {}}
            userId={profile.details.id}
            userFullName={profile.details.full_name}
            fullWidth
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
